/**
 * Client-side scope discriminant for tenant request surfaces (lookups, finance, activities, assets).
 * This is NOT sent to the backend: the API derives branch vs parish from the resolved request branch
 * (SYSTEM branch is parish, NORMAL branch is branch). It only drives client behaviour such as which
 * parish/branch lookups to fetch and how to label scope. The workspace-wide write flag is the separate
 * `WorkspaceScope.Shared` value.
 */
export enum TenantScopeContext {
  Branch = "branch",
  Parish = "parish",
  Shared = "shared",
}
